/** ISO country list with dial codes for profile phone/country fields. */
export const COUNTRIES = [
  { code: "AF", name: "Afghanistan", dial: "+93" },
  { code: "AL", name: "Albania", dial: "+355" },
  { code: "DZ", name: "Algeria", dial: "+213" },
  { code: "AS", name: "American Samoa", dial: "+1684" },
  { code: "AD", name: "Andorra", dial: "+376" },
  { code: "AO", name: "Angola", dial: "+244" },
  { code: "AI", name: "Anguilla", dial: "+1264" },
  { code: "AG", name: "Antigua and Barbuda", dial: "+1268" },
  { code: "AR", name: "Argentina", dial: "+54" },
  { code: "AM", name: "Armenia", dial: "+374" },
  { code: "AW", name: "Aruba", dial: "+297" },
  { code: "AU", name: "Australia", dial: "+61" },
  { code: "AT", name: "Austria", dial: "+43" },
  { code: "AZ", name: "Azerbaijan", dial: "+994" },
  { code: "BS", name: "Bahamas", dial: "+1242" },
  { code: "BH", name: "Bahrain", dial: "+973" },
  { code: "BD", name: "Bangladesh", dial: "+880" },
  { code: "BB", name: "Barbados", dial: "+1246" },
  { code: "BY", name: "Belarus", dial: "+375" },
  { code: "BE", name: "Belgium", dial: "+32" },
  { code: "BZ", name: "Belize", dial: "+501" },
  { code: "BJ", name: "Benin", dial: "+229" },
  { code: "BM", name: "Bermuda", dial: "+1441" },
  { code: "BT", name: "Bhutan", dial: "+975" },
  { code: "BO", name: "Bolivia", dial: "+591" },
  { code: "BA", name: "Bosnia and Herzegovina", dial: "+387" },
  { code: "BW", name: "Botswana", dial: "+267" },
  { code: "BR", name: "Brazil", dial: "+55" },
  { code: "IO", name: "British Indian Ocean Territory", dial: "+246" },
  { code: "VG", name: "British Virgin Islands", dial: "+1284" },
  { code: "BN", name: "Brunei", dial: "+673" },
  { code: "BG", name: "Bulgaria", dial: "+359" },
  { code: "BF", name: "Burkina Faso", dial: "+226" },
  { code: "BI", name: "Burundi", dial: "+257" },
  { code: "KH", name: "Cambodia", dial: "+855" },
  { code: "CM", name: "Cameroon", dial: "+237" },
  { code: "CA", name: "Canada", dial: "+1" },
  { code: "CV", name: "Cape Verde", dial: "+238" },
  { code: "KY", name: "Cayman Islands", dial: "+1345" },
  { code: "CF", name: "Central African Republic", dial: "+236" },
  { code: "TD", name: "Chad", dial: "+235" },
  { code: "CL", name: "Chile", dial: "+56" },
  { code: "CN", name: "China", dial: "+86" },
  { code: "CX", name: "Christmas Island", dial: "+61" },
  { code: "CC", name: "Cocos Islands", dial: "+61" },
  { code: "CO", name: "Colombia", dial: "+57" },
  { code: "KM", name: "Comoros", dial: "+269" },
  { code: "CK", name: "Cook Islands", dial: "+682" },
  { code: "CR", name: "Costa Rica", dial: "+506" },
  { code: "HR", name: "Croatia", dial: "+385" },
  { code: "CU", name: "Cuba", dial: "+53" },
  { code: "CW", name: "Curacao", dial: "+599" },
  { code: "CY", name: "Cyprus", dial: "+357" },
  { code: "CZ", name: "Czech Republic", dial: "+420" },
  { code: "CD", name: "Democratic Republic of the Congo", dial: "+243" },
  { code: "DK", name: "Denmark", dial: "+45" },
  { code: "DJ", name: "Djibouti", dial: "+253" },
  { code: "DM", name: "Dominica", dial: "+1767" },
  { code: "DO", name: "Dominican Republic", dial: "+1809" },
  { code: "TL", name: "East Timor", dial: "+670" },
  { code: "EC", name: "Ecuador", dial: "+593" },
  { code: "EG", name: "Egypt", dial: "+20" },
  { code: "SV", name: "El Salvador", dial: "+503" },
  { code: "GQ", name: "Equatorial Guinea", dial: "+240" },
  { code: "ER", name: "Eritrea", dial: "+291" },
  { code: "EE", name: "Estonia", dial: "+372" },
  { code: "ET", name: "Ethiopia", dial: "+251" },
  { code: "FK", name: "Falkland Islands", dial: "+500" },
  { code: "FO", name: "Faroe Islands", dial: "+298" },
  { code: "FJ", name: "Fiji", dial: "+679" },
  { code: "FI", name: "Finland", dial: "+358" },
  { code: "FR", name: "France", dial: "+33" },
  { code: "PF", name: "French Polynesia", dial: "+689" },
  { code: "GA", name: "Gabon", dial: "+241" },
  { code: "GM", name: "Gambia", dial: "+220" },
  { code: "GE", name: "Georgia", dial: "+995" },
  { code: "DE", name: "Germany", dial: "+49" },
  { code: "GH", name: "Ghana", dial: "+233" },
  { code: "GI", name: "Gibraltar", dial: "+350" },
  { code: "GR", name: "Greece", dial: "+30" },
  { code: "GL", name: "Greenland", dial: "+299" },
  { code: "GD", name: "Grenada", dial: "+1473" },
  { code: "GU", name: "Guam", dial: "+1671" },
  { code: "GT", name: "Guatemala", dial: "+502" },
  { code: "GG", name: "Guernsey", dial: "+44" },
  { code: "GN", name: "Guinea", dial: "+224" },
  { code: "GW", name: "Guinea-Bissau", dial: "+245" },
  { code: "GY", name: "Guyana", dial: "+592" },
  { code: "HT", name: "Haiti", dial: "+509" },
  { code: "HN", name: "Honduras", dial: "+504" },
  { code: "HK", name: "Hong Kong", dial: "+852" },
  { code: "HU", name: "Hungary", dial: "+36" },
  { code: "IS", name: "Iceland", dial: "+354" },
  { code: "IN", name: "India", dial: "+91" },
  { code: "ID", name: "Indonesia", dial: "+62" },
  { code: "IR", name: "Iran", dial: "+98" },
  { code: "IQ", name: "Iraq", dial: "+964" },
  { code: "IE", name: "Ireland", dial: "+353" },
  { code: "IM", name: "Isle of Man", dial: "+44" },
  { code: "IL", name: "Israel", dial: "+972" },
  { code: "IT", name: "Italy", dial: "+39" },
  { code: "CI", name: "Ivory Coast", dial: "+225" },
  { code: "JM", name: "Jamaica", dial: "+1876" },
  { code: "JP", name: "Japan", dial: "+81" },
  { code: "JE", name: "Jersey", dial: "+44" },
  { code: "JO", name: "Jordan", dial: "+962" },
  { code: "KZ", name: "Kazakhstan", dial: "+7" },
  { code: "KE", name: "Kenya", dial: "+254" },
  { code: "KI", name: "Kiribati", dial: "+686" },
  { code: "XK", name: "Kosovo", dial: "+383" },
  { code: "KW", name: "Kuwait", dial: "+965" },
  { code: "KG", name: "Kyrgyzstan", dial: "+996" },
  { code: "LA", name: "Laos", dial: "+856" },
  { code: "LV", name: "Latvia", dial: "+371" },
  { code: "LB", name: "Lebanon", dial: "+961" },
  { code: "LS", name: "Lesotho", dial: "+266" },
  { code: "LR", name: "Liberia", dial: "+231" },
  { code: "LY", name: "Libya", dial: "+218" },
  { code: "LI", name: "Liechtenstein", dial: "+423" },
  { code: "LT", name: "Lithuania", dial: "+370" },
  { code: "LU", name: "Luxembourg", dial: "+352" },
  { code: "MO", name: "Macau", dial: "+853" },
  { code: "MK", name: "Macedonia", dial: "+389" },
  { code: "MG", name: "Madagascar", dial: "+261" },
  { code: "MW", name: "Malawi", dial: "+265" },
  { code: "MY", name: "Malaysia", dial: "+60" },
  { code: "MV", name: "Maldives", dial: "+960" },
  { code: "ML", name: "Mali", dial: "+223" },
  { code: "MT", name: "Malta", dial: "+356" },
  { code: "MH", name: "Marshall Islands", dial: "+692" },
  { code: "MR", name: "Mauritania", dial: "+222" },
  { code: "MU", name: "Mauritius", dial: "+230" },
  { code: "YT", name: "Mayotte", dial: "+262" },
  { code: "MX", name: "Mexico", dial: "+52" },
  { code: "FM", name: "Micronesia", dial: "+691" },
  { code: "MD", name: "Moldova", dial: "+373" },
  { code: "MC", name: "Monaco", dial: "+377" },
  { code: "MN", name: "Mongolia", dial: "+976" },
  { code: "ME", name: "Montenegro", dial: "+382" },
  { code: "MS", name: "Montserrat", dial: "+1664" },
  { code: "MA", name: "Morocco", dial: "+212" },
  { code: "MZ", name: "Mozambique", dial: "+258" },
  { code: "MM", name: "Myanmar", dial: "+95" },
  { code: "NA", name: "Namibia", dial: "+264" },
  { code: "NR", name: "Nauru", dial: "+674" },
  { code: "NP", name: "Nepal", dial: "+977" },
  { code: "NL", name: "Netherlands", dial: "+31" },
  { code: "AN", name: "Netherlands Antilles", dial: "+599" },
  { code: "NC", name: "New Caledonia", dial: "+687" },
  { code: "NZ", name: "New Zealand", dial: "+64" },
  { code: "NI", name: "Nicaragua", dial: "+505" },
  { code: "NE", name: "Niger", dial: "+227" },
  { code: "NG", name: "Nigeria", dial: "+234" },
  { code: "NU", name: "Niue", dial: "+683" },
  { code: "KP", name: "North Korea", dial: "+850" },
  { code: "MP", name: "Northern Mariana Islands", dial: "+1670" },
  { code: "NO", name: "Norway", dial: "+47" },
  { code: "OM", name: "Oman", dial: "+968" },
  { code: "PK", name: "Pakistan", dial: "+92" },
  { code: "PW", name: "Palau", dial: "+680" },
  { code: "PS", name: "Palestine", dial: "+970" },
  { code: "PA", name: "Panama", dial: "+507" },
  { code: "PG", name: "Papua New Guinea", dial: "+675" },
  { code: "PY", name: "Paraguay", dial: "+595" },
  { code: "PE", name: "Peru", dial: "+51" },
  { code: "PH", name: "Philippines", dial: "+63" },
  { code: "PL", name: "Poland", dial: "+48" },
  { code: "PT", name: "Portugal", dial: "+351" },
  { code: "PR", name: "Puerto Rico", dial: "+1787" },
  { code: "QA", name: "Qatar", dial: "+974" },
  { code: "CG", name: "Republic of the Congo", dial: "+242" },
  { code: "RE", name: "Reunion", dial: "+262" },
  { code: "RO", name: "Romania", dial: "+40" },
  { code: "RU", name: "Russia", dial: "+7" },
  { code: "RW", name: "Rwanda", dial: "+250" },
  { code: "BL", name: "Saint Barthelemy", dial: "+590" },
  { code: "SH", name: "Saint Helena", dial: "+290" },
  { code: "KN", name: "Saint Kitts and Nevis", dial: "+1869" },
  { code: "LC", name: "Saint Lucia", dial: "+1758" },
  { code: "MF", name: "Saint Martin", dial: "+590" },
  { code: "PM", name: "Saint Pierre and Miquelon", dial: "+508" },
  { code: "VC", name: "Saint Vincent and the Grenadines", dial: "+1784" },
  { code: "WS", name: "Samoa", dial: "+685" },
  { code: "SM", name: "San Marino", dial: "+378" },
  { code: "ST", name: "Sao Tome and Principe", dial: "+239" },
  { code: "SA", name: "Saudi Arabia", dial: "+966" },
  { code: "SN", name: "Senegal", dial: "+221" },
  { code: "RS", name: "Serbia", dial: "+381" },
  { code: "SC", name: "Seychelles", dial: "+248" },
  { code: "SL", name: "Sierra Leone", dial: "+232" },
  { code: "SG", name: "Singapore", dial: "+65" },
  { code: "SX", name: "Sint Maarten", dial: "+1721" },
  { code: "SK", name: "Slovakia", dial: "+421" },
  { code: "SI", name: "Slovenia", dial: "+386" },
  { code: "SB", name: "Solomon Islands", dial: "+677" },
  { code: "SO", name: "Somalia", dial: "+252" },
  { code: "ZA", name: "South Africa", dial: "+27" },
  { code: "KR", name: "South Korea", dial: "+82" },
  { code: "SS", name: "South Sudan", dial: "+211" },
  { code: "ES", name: "Spain", dial: "+34" },
  { code: "LK", name: "Sri Lanka", dial: "+94" },
  { code: "SD", name: "Sudan", dial: "+249" },
  { code: "SR", name: "Suriname", dial: "+597" },
  { code: "SJ", name: "Svalbard and Jan Mayen", dial: "+47" },
  { code: "SZ", name: "Swaziland", dial: "+268" },
  { code: "SE", name: "Sweden", dial: "+46" },
  { code: "CH", name: "Switzerland", dial: "+41" },
  { code: "SY", name: "Syria", dial: "+963" },
  { code: "TW", name: "Taiwan", dial: "+886" },
  { code: "TJ", name: "Tajikistan", dial: "+992" },
  { code: "TZ", name: "Tanzania", dial: "+255" },
  { code: "TH", name: "Thailand", dial: "+66" },
  { code: "TG", name: "Togo", dial: "+228" },
  { code: "TK", name: "Tokelau", dial: "+690" },
  { code: "TO", name: "Tonga", dial: "+676" },
  { code: "TT", name: "Trinidad and Tobago", dial: "+1868" },
  { code: "TN", name: "Tunisia", dial: "+216" },
  { code: "TR", name: "Turkey", dial: "+90" },
  { code: "TM", name: "Turkmenistan", dial: "+993" },
  { code: "TC", name: "Turks and Caicos Islands", dial: "+1649" },
  { code: "TV", name: "Tuvalu", dial: "+688" },
  { code: "VI", name: "U.S. Virgin Islands", dial: "+1340" },
  { code: "UG", name: "Uganda", dial: "+256" },
  { code: "UA", name: "Ukraine", dial: "+380" },
  { code: "AE", name: "United Arab Emirates", dial: "+971" },
  { code: "GB", name: "United Kingdom", dial: "+44" },
  { code: "US", name: "United States", dial: "+1" },
  { code: "UY", name: "Uruguay", dial: "+598" },
  { code: "UZ", name: "Uzbekistan", dial: "+998" },
  { code: "VU", name: "Vanuatu", dial: "+678" },
  { code: "VA", name: "Vatican", dial: "+379" },
  { code: "VE", name: "Venezuela", dial: "+58" },
  { code: "VN", name: "Vietnam", dial: "+84" },
  { code: "WF", name: "Wallis and Futuna", dial: "+681" },
  { code: "EH", name: "Western Sahara", dial: "+212" },
  { code: "YE", name: "Yemen", dial: "+967" },
  { code: "ZM", name: "Zambia", dial: "+260" },
  { code: "ZW", name: "Zimbabwe", dial: "+263" },
];

const DEFAULT_COUNTRY = COUNTRIES.find((c) => c.code === "GB") || COUNTRIES[0];

/** Dial codes longest-first so +1684 matches before +1. */
const DIAL_CODES_DESC = Array.from(
  new Set(COUNTRIES.map((c) => c.dial.replace(/\D/g, "")))
)
  .filter(Boolean)
  .sort((a, b) => b.length - a.length);

/**
 * IANA timezone → ISO region. Used because browser language is often en-US
 * even when the user is elsewhere (e.g. Asia/Karachi + en-US → Pakistan).
 */
const TIMEZONE_TO_REGION = {
  "Asia/Karachi": "PK",
  "Asia/Colombo": "LK",
  "Asia/Dhaka": "BD",
  "Asia/Kolkata": "IN",
  "Asia/Calcutta": "IN",
  "Asia/Dubai": "AE",
  "Asia/Qatar": "QA",
  "Asia/Riyadh": "SA",
  "Asia/Kuwait": "KW",
  "Asia/Bahrain": "BH",
  "Asia/Muscat": "OM",
  "Asia/Tehran": "IR",
  "Asia/Kabul": "AF",
  "Asia/Tashkent": "UZ",
  "Asia/Almaty": "KZ",
  "Asia/Bangkok": "TH",
  "Asia/Jakarta": "ID",
  "Asia/Singapore": "SG",
  "Asia/Kuala_Lumpur": "MY",
  "Asia/Manila": "PH",
  "Asia/Hong_Kong": "HK",
  "Asia/Shanghai": "CN",
  "Asia/Tokyo": "JP",
  "Asia/Seoul": "KR",
  "Asia/Jerusalem": "IL",
  "Asia/Amman": "JO",
  "Asia/Beirut": "LB",
  "Asia/Baghdad": "IQ",
  "Europe/London": "GB",
  "Europe/Dublin": "IE",
  "Europe/Paris": "FR",
  "Europe/Berlin": "DE",
  "Europe/Amsterdam": "NL",
  "Europe/Brussels": "BE",
  "Europe/Madrid": "ES",
  "Europe/Rome": "IT",
  "Europe/Zurich": "CH",
  "Europe/Vienna": "AT",
  "Europe/Stockholm": "SE",
  "Europe/Oslo": "NO",
  "Europe/Copenhagen": "DK",
  "Europe/Helsinki": "FI",
  "Europe/Warsaw": "PL",
  "Europe/Prague": "CZ",
  "Europe/Budapest": "HU",
  "Europe/Bucharest": "RO",
  "Europe/Athens": "GR",
  "Europe/Istanbul": "TR",
  "Europe/Moscow": "RU",
  "Europe/Kyiv": "UA",
  "Europe/Kiev": "UA",
  "Africa/Cairo": "EG",
  "Africa/Lagos": "NG",
  "Africa/Johannesburg": "ZA",
  "Africa/Nairobi": "KE",
  "Africa/Casablanca": "MA",
  "America/New_York": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Los_Angeles": "US",
  "America/Phoenix": "US",
  "America/Toronto": "CA",
  "America/Vancouver": "CA",
  "America/Mexico_City": "MX",
  "America/Sao_Paulo": "BR",
  "America/Argentina/Buenos_Aires": "AR",
  "Australia/Sydney": "AU",
  "Australia/Melbourne": "AU",
  "Australia/Perth": "AU",
  "Pacific/Auckland": "NZ",
};

function regionFromLocaleTag(tag) {
  if (!tag) return "";
  const parts = String(tag).split(/[-_]/);
  if (parts.length < 2) return "";
  const region = String(parts[1] || "").toUpperCase();
  return region.length === 2 ? region : "";
}

function getTimezoneRegionCode() {
  try {
    if (typeof Intl === "undefined") return "";
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return TIMEZONE_TO_REGION[tz] || "";
  } catch (e) {
    return "";
  }
}

/** Flag emoji from ISO 3166-1 alpha-2 (e.g. PK → 🇵🇰). */
export function countryFlagEmoji(code) {
  const cc = String(code || "")
    .trim()
    .toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "";
  return Array.from(cc)
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join("");
}

/**
 * Detect region without geolocation.
 * Prefer timezone over language when they conflict — Chrome/OS language is often
 * en-US even when the user is in Pakistan (Asia/Karachi).
 */
export function getBrowserRegionCode() {
  try {
    const tzRegion = getTimezoneRegionCode();
    if (tzRegion && getCountryByCode(tzRegion)) return tzRegion;

    const locales = [];
    if (typeof navigator !== "undefined") {
      if (navigator.languages && navigator.languages.length) {
        locales.push(...navigator.languages);
      }
      if (navigator.language) locales.push(navigator.language);
    }
    try {
      if (typeof Intl !== "undefined") {
        locales.push(Intl.DateTimeFormat().resolvedOptions().locale);
      }
    } catch (e) {
      /* ignore */
    }

    for (let i = 0; i < locales.length; i += 1) {
      const region = regionFromLocaleTag(locales[i]);
      if (region && getCountryByCode(region)) return region;
    }
  } catch (e) {
    /* ignore */
  }
  return "GB";
}

export function getCountryByCode(code) {
  if (!code) return null;
  const normalized = String(code).trim().toUpperCase();
  return COUNTRIES.find((c) => c.code === normalized) || null;
}

export function getCountryByName(name) {
  if (!name) return null;
  const normalized = String(name).trim().toLowerCase();
  if (!normalized) return null;

  const aliases = {
    uk: "GB",
    "u.k.": "GB",
    "u.k": "GB",
    "great britain": "GB",
    britain: "GB",
    england: "GB",
    scotland: "GB",
    wales: "GB",
    "northern ireland": "GB",
    eire: "IE",
    "republic of ireland": "IE",
    "irish republic": "IE",
  };
  if (aliases[normalized]) {
    return getCountryByCode(aliases[normalized]);
  }

  return (
    COUNTRIES.find((c) => c.name.toLowerCase() === normalized) ||
    COUNTRIES.find((c) => c.name.toLowerCase().includes(normalized)) ||
    null
  );
}

export function getCountriesByDial(dial) {
  const digits = String(dial || "").replace(/\D/g, "");
  if (!digits) return [];
  return COUNTRIES.filter((c) => c.dial.replace(/\D/g, "") === digits);
}

export function getCountryByDial(dial) {
  const matches = getCountriesByDial(dial);
  if (!matches.length) return null;
  const preferred = getDefaultCountry();
  if (preferred && matches.some((c) => c.code === preferred.code)) {
    return preferred;
  }
  // Shared dials (e.g. +1): prefer United States when no other hint is given.
  return matches.find((c) => c.code === "US") || matches[0];
}

/**
 * Pick which country row to show for a dial code when several share it (+1 US/CA).
 * Prefers the profile country name/code when its dial matches.
 */
export function resolveDialCountry(dial, preferredNameOrCode) {
  const matches = getCountriesByDial(dial);
  const preferred =
    getCountryByName(preferredNameOrCode) ||
    getCountryByCode(preferredNameOrCode) ||
    null;

  if (preferred) {
    if (!matches.length || matches.some((c) => c.code === preferred.code)) {
      return preferred;
    }
  }
  if (matches.length) {
    const fallback = getDefaultCountry();
    if (fallback && matches.some((c) => c.code === fallback.code)) {
      return fallback;
    }
    return matches.find((c) => c.code === "US") || matches[0];
  }
  return preferred || getDefaultCountry();
}

/** Only these ISO codes are selectable until more markets open. */
export const ENABLED_COUNTRY_CODES = ["PK", "IE", "GB"];

/** Backend country table ids (dealer profile uses the same). */
export const COUNTRY_API_IDS = {
  PK: 1,
  IE: 2,
  GB: 3,
};

export function isCountryEnabled(codeOrName) {
  if (codeOrName == null || codeOrName === "") return false;
  if (typeof codeOrName === "object") {
    return isCountryEnabled(
      codeOrName.code || codeOrName.name || codeOrName.id
    );
  }
  const asString = String(codeOrName).trim();
  // Legacy numeric ids from the API.
  if (asString === "1" || asString === "2" || asString === "3") {
    const byId = getCountryByApiId(asString);
    return Boolean(byId && ENABLED_COUNTRY_CODES.includes(byId.code));
  }
  const country =
    getCountryByCode(asString) || getCountryByName(asString) || null;
  if (!country) return false;
  return ENABLED_COUNTRY_CODES.includes(country.code);
}

/** Value sent in PUT `country` — Pakistan → 1. */
export function countryToApiId(nameOrCode) {
  if (nameOrCode == null || nameOrCode === "") return "";
  if (String(nameOrCode).trim() === "1") return 1;
  const country =
    getCountryByCode(nameOrCode) || getCountryByName(nameOrCode) || null;
  if (!country) return "";
  const id = COUNTRY_API_IDS[country.code];
  return id == null ? "" : id;
}

export function getCountryByApiId(id) {
  const numeric = Number(id);
  if (!Number.isFinite(numeric)) return null;
  const code = Object.keys(COUNTRY_API_IDS).find(
    (key) => COUNTRY_API_IDS[key] === numeric
  );
  return code ? getCountryByCode(code) : null;
}

export function getDefaultCountry() {
  // Prefer an enabled market from the browser locale when several are open.
  const preferred =
    getCountryByCode(getBrowserRegionCode()) || DEFAULT_COUNTRY;
  if (preferred && isCountryEnabled(preferred.code)) {
    return preferred;
  }
  const firstEnabled = getCountryByCode(ENABLED_COUNTRY_CODES[0]);
  return firstEnabled || preferred || DEFAULT_COUNTRY;
}

export function normalizeDial(dial) {
  const digits = String(dial || "").replace(/\D/g, "");
  return digits ? `+${digits}` : "";
}

export function splitPhone(mobile) {
  const raw = String(mobile || "").trim();
  const defaultCountry = getDefaultCountry();
  if (!raw) {
    return {
      dial: defaultCountry.dial,
      national: "",
      country: defaultCountry,
    };
  }

  const withPlus = raw.startsWith("+") ? raw : raw.startsWith("00") ? `+${raw.slice(2)}` : "";
  if (withPlus) {
    const digits = withPlus.replace(/\D/g, "");
    for (let i = 0; i < DIAL_CODES_DESC.length; i += 1) {
      const code = DIAL_CODES_DESC[i];
      if (digits.startsWith(code)) {
        const country = getCountryByDial(code) || defaultCountry;
        return {
          dial: `+${code}`,
          national: digits.slice(code.length),
          country,
        };
      }
    }
    return {
      dial: defaultCountry.dial,
      national: digits,
      country: defaultCountry,
    };
  }

  return {
    dial: defaultCountry.dial,
    national: raw.replace(/[^\d]/g, ""),
    country: defaultCountry,
  };
}

export function joinPhone(dial, national) {
  const dialDigits = String(dial || "").replace(/\D/g, "");
  const nationalDigits = String(national || "").replace(/\D/g, "");
  if (!nationalDigits) return "";
  if (!dialDigits) return nationalDigits;
  return `+${dialDigits}${nationalDigits}`;
}

/**
 * Resolve country name for the form, falling back to browser locale.
 * Accepts API name string, ISO code, or { id, name }.
 */
export function resolveCountryName(value) {
  if (value == null || value === "") {
    return getDefaultCountry().name;
  }
  if (typeof value === "object") {
    const fromId = getCountryByApiId(value.id);
    if (fromId) return fromId.name;
    return (
      resolveCountryName(value.name || value.country || value.code) ||
      getDefaultCountry().name
    );
  }
  const asString = String(value).trim();
  if (!asString) return getDefaultCountry().name;
  const fromApiId = getCountryByApiId(asString);
  if (fromApiId) return fromApiId.name;
  const byName = getCountryByName(asString);
  if (byName) return byName.name;
  const byCode = getCountryByCode(asString);
  if (byCode) return byCode.name;
  // Keep unknown legacy string so user can still see/edit via select if it matches an option
  return asString;
}

export function resolveDialForCountryName(countryName, fallbackDial) {
  const country = getCountryByName(countryName) || getDefaultCountry();
  return country?.dial || fallbackDial || getDefaultCountry().dial;
}
